import { useCallback, useMemo, useState } from "react";

import { addJWTInConfig } from "../../components/apiHooks/helpers";
import useApiRequestPost from "../../components/apiHooks/useApiRequestPost";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";

const PAYMENT_HOST: string = process.env.TERMINAL_HOST ?? "";
const END_POINT: string = process.env.API_PRINT ?? "";

const url: string = `${PAYMENT_HOST}${END_POINT}`;

const usePostPrint = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);
	const {
		state: { user },
	} = useConfigContext((state) => state);

	const payload = useMemo(
		() => ({
			url,
			triggerOnMount: false,
			axiosConfig: addJWTInConfig(undefined, user?.session_id?.toString() ?? ""),
			body: {},
			swrConfig: {
				revalidateOnFocus: false,
				revalidateOnReconnect: false,
				revalidateIfStale: false,
				shouldRetryOnError: false,
				errorRetryInterval: 0,
				errorRetryCount: 0,
				revalidate: false,
			},
		}),
		[user?.session_id]
	);

	const { data: response, postData } = useApiRequestPost(payload);

	const submitPrint = useCallback(
		async (stubs: string[]) => {
			setIsLoading(true);
			setError(null);

			try {
				for (let i = 0; i < stubs.length; i++) {
					await postData(JSON.parse(stubs[i]));

					if (i < stubs.length - 1) {
						await new Promise((resolve) => setTimeout(resolve, 800));
					}
				}

				setIsLoading(false);
			} catch (err) {
				setError(err instanceof Error ? err : new Error("Print request failed"));
				setIsLoading(false);
				throw err;
			}
		},
		[postData]
	);

	return {
		submitPrint,
		isLoading,
		error,
		response,
	};
};

export default usePostPrint;
